import React, { FC } from 'react'

import * as SC from './styled'

type Item = {
  id: string
  label: string
  selected?: boolean
  disabled?: boolean
}

export type SlotsProps = {
  className?: string

  title: string
  items: Array<Item>

  onChange: (item: Item) => void
}

const Slots: FC<SlotsProps> = (props) => {
  const { className, title, items, onChange } = props

  return (
    <SC.Container className={className}>
      <SC.Title>{title}</SC.Title>
      <SC.Items>
        {items.map((item) => (
          <SC.Item
            key={`${item.id}-${item.selected ? '0' : '1'}`}
            $selected={item.selected}
            disabled={item.disabled}
            onClick={() => onChange(item)}
          >
            {item.label}
          </SC.Item>
        ))}
      </SC.Items>
    </SC.Container>
  )
}

export default Slots
